<template>
  <div class="min-h-screen bg-slate-900 flex items-center justify-center px-4">
    <div class="w-full max-w-sm">

      <!-- Logo / cabecera -->
      <div class="text-center mb-8">
        <div class="inline-flex items-center justify-center w-16 h-16 rounded-2xl
                    bg-gradient-to-br from-emerald-500 to-emerald-700 shadow-lg mb-4">
          <i class="fa-solid fa-key text-white text-2xl"></i>
        </div>
        <h1 class="text-2xl font-bold text-white">¿Olvidaste tu contraseña?</h1>
        <p class="text-slate-400 text-sm mt-1">Te enviaremos un enlace para restablecerla</p>
      </div>

      <!-- Card -->
      <div class="bg-slate-800 rounded-2xl shadow-xl p-8 border border-slate-700">

        <!-- Éxito -->
        <div v-if="enviado" class="text-center">
          <div class="text-5xl mb-4">📬</div>
          <h2 class="text-emerald-400 font-semibold text-lg mb-2">Correo enviado</h2>
          <p class="text-slate-300 text-sm leading-relaxed">
            Si el correo está registrado, recibirás un enlace en los próximos minutos.<br>
            Revisa también tu carpeta de spam.
          </p>
          <router-link :to="{ name: 'Login' }"
            class="mt-6 inline-block text-emerald-500 hover:text-emerald-300 text-sm transition">
            ← Volver al inicio de sesión
          </router-link>
        </div>

        <!-- Formulario -->
        <form v-else @submit.prevent="enviar">

          <!-- Error -->
          <div v-if="errorMsg"
            class="mb-4 bg-red-900/40 border border-red-500/50 text-red-300 text-sm px-4 py-3 rounded-xl">
            {{ errorMsg }}
          </div>

          <!-- Email -->
          <div class="mb-6">
            <label class="block text-sm font-medium text-slate-300 mb-2">
              <i class="fa-solid fa-envelope mr-2 text-emerald-400"></i>Correo electrónico
            </label>
            <input
              v-model="email"
              type="email"
              placeholder="tu@correo.com"
              class="w-full bg-slate-700 text-white placeholder-slate-500
                     border border-slate-600 rounded-xl px-4 py-3 text-sm
                     focus:outline-none focus:border-emerald-500 focus:ring-1 focus:ring-emerald-500 transition"
            />
          </div>

          <!-- Botón -->
          <button
            type="submit"
            :disabled="cargando"
            class="w-full bg-gradient-to-r from-emerald-600 to-emerald-700
                   hover:from-emerald-500 hover:to-emerald-600 disabled:opacity-60
                   text-white font-semibold py-3 rounded-xl transition shadow-md"
          >
            <span v-if="cargando">
              <i class="fa-solid fa-spinner fa-spin mr-2"></i>Enviando…
            </span>
            <span v-else>
              <i class="fa-solid fa-paper-plane mr-2"></i>Enviar enlace
            </span>
          </button>

        </form>
      </div>

      <!-- Volver al login -->
      <div v-if="!enviado" class="text-center mt-6">
        <router-link :to="{ name: 'Login' }"
          class="text-slate-500 hover:text-slate-300 text-sm transition">
          <i class="fa-solid fa-arrow-left mr-1"></i> Volver al inicio de sesión
        </router-link>
      </div>

    </div>
  </div>
</template>

<script>
import authService from '@/services/auth.service'

export default {
  name: 'OlvidePasswordView',
  data () {
    return {
      email:    '',
      cargando: false,
      enviado:  false,
      errorMsg: ''
    }
  },
  methods: {
    async enviar () {
      this.errorMsg = ''
      if (!this.email.trim()) {
        this.errorMsg = 'Por favor ingresa tu correo electrónico.'
        return
      }
      this.cargando = true
      try {
        await authService.olvideMiPassword(this.email.trim().toLowerCase())
        this.enviado = true
      } catch {
        this.errorMsg = 'Ocurrió un error. Inténtalo más tarde.'
      } finally {
        this.cargando = false
      }
    }
  }
}
</script>
